import { connect } from 'react-redux'
import List from '../components/List'
import { GET_DEPOSITS } from '../actions'

const mapStateToProps = state => {
  const { tiers, firstYrInterest, blendedAPY } = state.deposits

  return {
    tiers,
    firstYrInterest,
    blendedAPY,
  }
}
const mapDispatchToProps = dispatch => ({
  getDeposits: () => dispatch({ type: GET_DEPOSITS }),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(List)



// WEBPACK FOOTER //
// ./src/containers/List.js